import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { ALARM_TIMELINE } from './url-constants';

type AlarmTimelineEndpointSpecification = ApiEndpointSpecification;
export const AlarmTimelineEndpointSpecification: AlarmTimelineEndpointSpecification = {
    url: ALARM_TIMELINE,
    method: HttpMethod.POST,
    requestParamsSchemaName: 'AlarmTimelineRequestParams',
    requestBodySchemaName: 'AlarmTimelineRequestBody',
    okResponseSchemaName: 'AlarmTimelineOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeAlarmTimeline = Helpers.makeApiRequestFn<
    Types.AlarmTimelineRequestParams,
    Types.AlarmTimelineRequestBody,
    Types.AlarmTimelineOkResponse
>(AlarmTimelineEndpointSpecification);
